/**
 * Reports & Analytics Main Page — clean tabbed layout
 */
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import DailyReplenishmentPlan from './DailyReplenishmentPlan';
import StockStatusReport from './StockStatusReport';
import OrderTrackingReport from './OrderTrackingReport';
import StockoutAnalysisReport from './StockoutAnalysisReport';
import ExcessInventoryReport from './ExcessInventoryReport';
import TabPanel from '../Common/TabPanel';

const ReportsPage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      {/* Page title */}
      <Box sx={{ mb: '20px' }}>
        <Typography sx={{ fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-text-primary)', fontFamily: 'var(--font-heading)' }}>
          Reports & Analytics
        </Typography>
        <Typography sx={{ fontSize: 'var(--text-base)', color: 'var(--color-text-muted)', mt: 0.5, fontFamily: 'var(--font-body)' }}>
          Operational reports for inventory management and decision making
        </Typography>
      </Box>

      {/* Tab navigation */}
      <Box sx={{ borderBottom: '1px solid var(--color-border)', mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Daily Replenishment" />
          <Tab label="Stock Status" />
          <Tab label="Order Tracking" />
          <Tab label="Stockout Analysis" />
          <Tab label="Excess Inventory" />
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box className="page-enter">
        <TabPanel value={currentTab} index={0}>
          <DailyReplenishmentPlan />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <StockStatusReport />
        </TabPanel>
        <TabPanel value={currentTab} index={2}>
          <OrderTrackingReport />
        </TabPanel>
        <TabPanel value={currentTab} index={3}>
          <StockoutAnalysisReport />
        </TabPanel>
        <TabPanel value={currentTab} index={4}>
          <ExcessInventoryReport />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default ReportsPage;
